// extracted by mini-css-extract-plugin
export default {"component":"b1KzG9","cancel":"c1KzG9","results":"d1KzG9"};